"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageRecordMetadataSchema = exports.SigmaModelInferenceSchema = exports.SigmaModelInferenceSource = void 0;
exports.parsePackageRecordMetadata = parsePackageRecordMetadata;
exports.withSigmaModelInference = withSigmaModelInference;
exports.latestSigmaModelInference = latestSigmaModelInference;
exports.heuristicSigmaModelParameters = heuristicSigmaModelParameters;
exports.isSigmaModelClassificationSettled = isSigmaModelClassificationSettled;
const z = require("zod");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const package_store_package_resolution_1 = require("./package-store-package-resolution");
const package_understanding_failure_1 = require("./package-understanding-failure");
const package_datasheet_provenance_1 = require("./package-datasheet-provenance");
var SigmaModelInferenceSource;
(function (SigmaModelInferenceSource) {
    SigmaModelInferenceSource["HeuristicResolver"] = "heuristic_resolver";
    SigmaModelInferenceSource["AiDatasheetClassifier"] = "ai_datasheet_classifier";
})(SigmaModelInferenceSource || (exports.SigmaModelInferenceSource = SigmaModelInferenceSource = {}));
exports.SigmaModelInferenceSchema = z.object({
    sigmaModelId: z.string().min(1),
    sigmaModelParameters: z.record(z.string(), z.unknown()).optional(),
    source: z.nativeEnum(SigmaModelInferenceSource),
    inferredAt: z.string(),
});
exports.PackageRecordMetadataSchema = z
    .object({
    sigmaModelInferences: z.array(exports.SigmaModelInferenceSchema).optional(),
    understandingFailure: package_understanding_failure_1.PackageUnderstandingFailureSchema.optional(),
    datasheetProvenance: package_datasheet_provenance_1.PackageDatasheetProvenanceSchema.optional(),
})
    .passthrough();
function parsePackageRecordMetadata(value) {
    if (value === null || value === undefined) {
        return undefined;
    }
    const parsed = exports.PackageRecordMetadataSchema.safeParse(value);
    return parsed.success ? parsed.data : undefined;
}
function withSigmaModelInference(metadata, inference) {
    const others = (metadata?.sigmaModelInferences ?? []).filter((entry) => entry.source !== inference.source);
    return {
        ...metadata,
        sigmaModelInferences: [...others, inference],
    };
}
function latestSigmaModelInference(metadata) {
    const inferences = metadata?.sigmaModelInferences ?? [];
    return inferences.reduce((latest, entry) => (latest === undefined || entry.inferredAt >= latest.inferredAt ? entry : latest), undefined);
}
function heuristicSigmaModelParameters(metadata, sigmaModelType) {
    const inference = metadata?.sigmaModelInferences?.find((entry) => entry.source === SigmaModelInferenceSource.HeuristicResolver && entry.sigmaModelId === sigmaModelType);
    const parameters = {};
    for (const [name, raw] of Object.entries(inference?.sigmaModelParameters ?? {})) {
        const parsed = sigma_engine_shared_1.StoredValueVarianceSchema.safeParse(raw);
        if (parsed.success && parsed.data.value !== undefined) {
            parameters[name] = parsed.data;
        }
    }
    return parameters;
}
function isSigmaModelClassificationSettled(sigmaModelType, inference) {
    if (sigmaModelType !== package_store_package_resolution_1.UNCLASSIFIED_SIGMA_MODEL_ID) {
        return true;
    }
    return (inference?.sigmaModelId === package_store_package_resolution_1.UNCLASSIFIED_SIGMA_MODEL_ID &&
        inference.source === SigmaModelInferenceSource.AiDatasheetClassifier);
}
//# sourceMappingURL=package-record-metadata.js.map